"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns a function which accepts no params and returns the passed value
 *
 * @module concat
 * @func
 * @since 1.16.0
 * @param {*} val
 * @return {function}
 * @example
 *
 *     cast(6); //=> () = 6;
 */

var cast = function cast(val) {
  return function () {
    return val;
  };
};

exports.default = cast;